import { useContext } from 'react';
import DataTable from 'react-data-table-component';
import { columnasmovimientos, customStylesMovimientos, opcionesdepagina } from './tableOptions';
import { ProductContext } from '../../context/ProductContext';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useState } from 'react';

function ExpandableComponent({ data }) {

  const { getProductosByIds } = useContext(ProductContext);
  const [productos, setProductos] = useState([]);

  async function getAndAsign() {
    let ids;
    ids = data.ventas.concat(data.devoluciones);
    const productos = await getProductosByIds(ids);
    if (productos.length > 0) {
      let tablaFinal = productos.map((prod) => {
        if (data.ventas.includes(prod._id.toString()) || data.ventas.includes(`${prod.UserId}.${prod.codigoProducto}`)) {
          prod.operacion = 'Vendido';
        }
        if (data.devoluciones.includes(prod._id.toString()) || data.devoluciones.includes(`${prod.UserId}.${prod.codigoProducto}`)) {
          prod.operacion = 'Devuelto';
        }
        return prod;
      });
      setProductos(tablaFinal);
    }
  }

  useEffect(() => {
    getAndAsign();
  }, [])

  return (
    <DataTable
      data={productos}
      customStyles={customStylesMovimientos}
      columns={columnasmovimientos}
      pagination
      paginationComponentOptions={opcionesdepagina}
    />
  );

}

ExpandableComponent.propTypes = {
  data: PropTypes.object
};

export default ExpandableComponent;
